import React from 'react';
import './PulsingGlow.css';

interface PulsingGlowProps {
  width?: string;
  height?: string;
  color?: string;
  duration?: number;
  className?: string;
}

const PulsingGlow: React.FC<PulsingGlowProps> = ({
  width = '100%',
  height = '100px',
  color = 'white',
  duration = 3,
  className = ''
}) => {
  return (
    <div 
      className={`pulsing-glow ${className}`}
      style={{ 
        width, 
        height,
        '--glow-color': color,
        '--animation-duration': `${duration}s`
      } as React.CSSProperties}
    >
      <div className="glow-left"></div>
      <div className="glow-center"></div>
      <div className="glow-right"></div>
    </div>
  );
};

export default PulsingGlow;